import { IProject } from '../../../projects.types'
import ProjectDescriptionCard from 'screens/Projects/components/Cards/ProjectDescriptionCard'
import ProjectMotivationCard from 'screens/Projects/components/Cards/ProjectMotivationCard'
import ProjectExpectingResultsCard from 'screens/Projects/components/Cards/ProjectExpectingResultsCard'
import ProjectTechStackCard from 'screens/Projects/components/Cards/ProjectTechStackCard'
import ProjectInfoCard from 'screens/Projects/components/Cards/ProjectInfoCard'
import ProjectRolesCard from 'screens/Projects/components/Cards/ProjectRolesCard'
import ProjectTeamsCard from 'screens/Projects/components/Cards/ProjectTeamsCard'
import useProjectsActions from 'screens/Projects/hooks/useProjectsActions'
import { useSetRecoilState } from 'recoil'
import selfProjectsAtom from 'screens/Auth/components/InitProvider/selfProjects.atom'

interface IProps {
  project: IProject
  onLeft: () => void
}

const ProjectInfoContent = (props: IProps) => {
  const actions = useProjectsActions()
  const setSelfProject = useSetRecoilState(selfProjectsAtom)

  const handleLeft = (updatedProject: IProject) => {
    setSelfProject((prev) => ({
      ...prev,
      items: prev.items.filter((selfProject) => selfProject.id !== updatedProject.id),
    }))
    props.onLeft()
    actions.projectUpdated(updatedProject)
  }

  const handleUpdated = (updatedProject: Partial<IProject>) => {
    actions.projectUpdated({ ...props.project, ...updatedProject })
  }
  return (
    <div className='flex-lines gap24'>
      <ProjectTeamsCard project={props.project} onJoined={() => {}} onUpdated={handleUpdated} onLeft={handleLeft} />
      <ProjectRolesCard project={props.project} onLeft={handleLeft} />
      <ProjectInfoCard project={props.project} />
      <ProjectDescriptionCard project={props.project} />
      <ProjectMotivationCard project={props.project} />
      <ProjectExpectingResultsCard project={props.project} />
      <ProjectTechStackCard project={props.project} />
    </div>
  )
}

export default ProjectInfoContent
